import { AreaUnit } from '../../../../../shared/graphql/graphql';

const TRIAL_AREA_AMOUNTS = {
  [AreaUnit.Acres]: 250,
  [AreaUnit.Hectares]: 100,
} as Record<AreaUnit, number>;

export default TRIAL_AREA_AMOUNTS;
